export default "__VITE_ASSET__jHHk0wHK__"